import React from 'react';
import Typography from '../components/Typography';

const ComingSoon = () => {
  return (
    <div className="ps-coming-soon">
      <div>
        <Typography className="h2">Coming Soon</Typography>
        <p>Stay tuned. We are launching soon...</p>
      </div>
    </div>
  );
};

export default ComingSoon;
